import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Redirect, Route, Switch } from 'react-router-dom'
import UserAreaProfile from './Profile/UserAreaProfile'
import UserAreaVehicles from './Vehicles/UserAreaVehicles'
import UserAreaMarks from './Mark/UserAreaMarks'

import './UserArea.css'
import RenewModal from '../../components/RenewModal'
import OrdersHistory from './OrdersHistory/OrdersHistory'
import { AdjustemntAlert } from '../../components/Alert/AdjustemntAlert'
import Modal from 'react-responsive-modal'
import SostaOnlineApiService from '../../services/SostaOnlineApiService'
import UserAreaParkTickets from "./ParkTicket/UserAreaParkTickets";
import WaitingLists from "./WaitingLists/WaitingLists";

export default class UserArea extends Component {
  static propTypes = {
    onRenewMark: PropTypes.func.isRequired,
    onOpenRenewMarkModal: PropTypes.func.isRequired,
    onCloseRenewMarkModal: PropTypes.func.isRequired,
    showRenewMarkModal: PropTypes.bool,
    renewingMark: PropTypes.object,
    renewErrors: PropTypes.string,
    userAdjustment: PropTypes.object,
    onAdjustmentPay: PropTypes.func,
    merger: PropTypes.array
  }

  constructor (props) {
    super(props)
    this.state = {
      vehicleEditing: {}
    }

    this.isUserBelongsToCategory = this.isUserBelongsToCategory.bind(this)
  }

  isUserBelongsToCategory (categoryId) {
    if (!this.props.user.categories) {
      return false
    }

    let filtered = this.props.user.categories.filter(item => {
      return item.id === categoryId
    })

    return filtered.length > 0
  }

  onVehicleEditClick (vehicle) {
    let vehiclesEditing = {}
    vehiclesEditing[vehicle.id] = true
    this.setState({vehicleEditing: vehiclesEditing})
  }

  render () {
    const {
      renewingMark,
      showRenewMarkModal,
      onRenewMark,
      onOpenRenewMarkModal,
      onCloseRenewMarkModal,
      renewErrors,
      userAdjustment
    } = this.props
    return (
      <div>
        <div className="row">
          <div className="col-md-10 col-md-offset-2">
            {!this.props.user.userConfirmed && <div>
              <h5 className="title-danger">
                <strong>Attenzione! </strong>
                Non hai ancora confermato la tua mail,{' '}
                il download e l'acquisto dei contrassegni sarà disponibile solo a mail confermata
              </h5>
            </div>}
          </div>
        </div>

        {/* this.props.userAdjustment ? (
          <AdjustemntAlert
            onPay={this.props.onAdjustmentPay}
            isBackOffice={false}
            adjustment={userAdjustment}
          />
        ) : (
          <div className="col-md-12 alert alert-success">
            <div>
              La tua posizione per il 2018 è attualmente <strong>regolarizzata</strong>.<br />
              Per il rinnovo 2019 ritorna su questa piattaforma (oppure rivolgiti allo sportello) a partire dal 2 gennaio 2019.<br />
              Per richiesta di nuovi contrassegni e/o modifica di contrassegni esistenti rivolgersi allo Sportello Smart Mobility.
            </div>
          </div>
        ) */}

        {this.props.merger && this.props.merger.length > 0 && (
          <React.Fragment>
            <Modal
              open={this.props.merger[0].merged === 0}
              showCloseIcon={false}
              closeOnEsc={false}
              closeOnOverlayClick={false}
              classNames={{modal: 'mdl'}}>
              <div>
                <h3 style={{textAlign: 'center', marginBottom: '1rem'}}>
                  Il sistema ha trovato dei dati in archivio che sembrano corrispondere al tuo profilo.
                </h3>
                <p style={{textAlign: 'left', marginBottom: '1rem'}}>
                  Confermi che questi dati sono corretti?
                </p>
                <div style={{textAlign: 'left', fontSize: '1.3rem'}}>
                  <h5 style={{margin: 0}}><b>Codice Fiscale :</b> {this.props.merger[0].fiscalCode}</h5>
                  <h5 style={{marginTop: '.5rem', marginBottom: 0}}><b>Nome e Cognome :</b> {this.props.merger[0].firstName} {this.props.merger[0].lastName}</h5>
                  <h5 style={{marginTop: '.5rem', marginBottom: '3rem'}}><b>Targhe Veicoli: </b>
                    {this.props.merger[0].vehicle1 ? this.props.merger[0].vehicle1 : '/'}
                    {this.props.merger[0].vehicle2 ? ' - ' + this.props.merger[0].vehicle2 : ''}
                    {this.props.merger[0].vehicle3 ? ' - ' + this.props.merger[0].vehicle3 : ''}
                  </h5>
                  <p>
                    Se sei un utente già in possesso di un contrassegno
                    cliccando su CONFERMO il sistema assocerà
                    automaticamente i dati storici presenti in archivio
                    al tuo profilo (veicoli, contrassegno, ecc.).
                    Cliccando invece su NON CONFERMO ti registrerai come
                    utente ex novo
                  </p>
                </div>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                  <button onClick={this.props.onMergeConfirm} className="btn btn-info" style={{marginRight: '1rem', flex: 1}}>CONFERMO</button>
                  <button onClick={this.props.onMergeRefuse} className="btn btn-warning" style={{flex: 1}}>NON CONFERMO</button>
                </div>
              </div>
            </Modal>
          </React.Fragment>

        )
        }

        <Switch>
          <Route path={'/user-area/profile'} component={(props) => <div>
            <UserAreaProfile {...this.props} {...props} />
            <UserAreaVehicles {...this.props} {...props} />
            <UserAreaMarks
              onOpenRenewMarkModal={onOpenRenewMarkModal}
              onCloseRenewMarkModal={onCloseRenewMarkModal}
              {...this.props}
              {...props}
            />
            <UserAreaParkTickets {...this.props} {...props} />
          </div>} />
          <Route path={'/user-area/vehicles'} component={(props) => <UserAreaVehicles {...this.props} {...props} />} />
          <Route path={'/user-area/marks'} component={(props) => <UserAreaMarks
            onOpenRenewMarkModal={this.onOpenRenewMarkModal}
            onCloseRenewMarkModal={this.onCloseRenewMarkModal}
            {...this.props}
            {...props}
          />} />
          <Route path={'/user-area/order-history'} component={OrdersHistory} />
          <Route
            path={'/user-area/park-tickets'}
            component={(props) => <UserAreaParkTickets {...this.props} {...props} />} />
          <Route path={'/user-area/waiting-lists'} component={WaitingLists} />
          <Redirect to={'/user-area/profile'} />
        </Switch>

        <RenewModal
          mark={renewingMark}
          show={showRenewMarkModal}
          onRenewMark={onRenewMark}
          renewErrors={renewErrors}
          onClose={onCloseRenewMarkModal}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/UserArea/UserArea.js